import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  "class": "position-relative date"
};
var _hoisted_2 = {
  "class": "position-absolute top-50 start-50 translate-middle text-white sh-background-gray-blueish rounded-pill px-1 z-2"
};
var _hoisted_3 = {
  "class": "flex-shrink-0 d-none d-md-block"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "flex-grow-1 ms-md-3"
};
var _hoisted_6 = {
  "class": "d-flex align-items-center mb-4"
};
var _hoisted_7 = {
  "class": "font-size-14 font-weight-semibold"
};
var _hoisted_8 = {
  "class": "sh-color-gray-3 opacity-75 font-size-10 ms-2"
};
var _hoisted_9 = {
  "class": "content font-size-12"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  key: 0,
  "class": "products-list rounded-3 bg-lighter-blue overflow-hidden mb-2 mt-3"
};
var _hoisted_12 = {
  "class": "scrollbox scroll-list overflow-y-auto"
};
var _hoisted_13 = {
  "class": "d-flex align-items-center py-2 px-3 list position-relative"
};
var _hoisted_14 = {
  "class": "flex-grow-1"
};
var _hoisted_15 = {
  "class": "d-flex align-items-center"
};
var _hoisted_16 = {
  "class": "flex-shrink-0 img-fit d-flex align-items-center overflow-hidden rounded-3"
};
var _hoisted_17 = {
  "class": "ms-2"
};
var _hoisted_18 = {
  "class": "font-size-11"
};
var _hoisted_19 = {
  "class": "font-size-12 font-family-raleway font-weight-semibold"
};
var _hoisted_20 = {
  "class": "flex-shrink-0"
};
var _hoisted_21 = ["value"];
var _hoisted_22 = {
  key: 1,
  "class": "attachement mb-4"
};
var _hoisted_23 = {
  "class": "d-flex align-items-center font-size-11 my-1 uploading-item"
};
var _hoisted_24 = ["src"];
var _hoisted_25 = ["href"];
var _hoisted_26 = {
  "class": "font-size-10 sh-color-gray-3 opacity-75 ms-2"
};
import { useDateFormat } from '@vueuse/core';
import { messageAvatar, messageSender } from '@dashboardApp/helpers/inbox';
import { unixTimestampToDate } from '@dashboardApp/helpers/date';
import LazyImage from '@dashboardApp/components/LazyImage.vue';
export default {
  __name: 'DatedMessagesInner',
  props: {
    messages: {
      type: Object,
      "default": {}
    },
    date: String,
    messageRowClass: {
      type: String,
      "default": 'my-4'
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(useDateFormat)(__props.date, 'MMMM D').value), 1), _cache[0] || (_cache[0] = _createElementVNode("hr", {
        "class": "border-gray-blueish opacity-40"
      }, null, -1))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, function (message) {
        return _openBlock(), _createElementBlock("div", {
          "class": _normalizeClass([__props.messageRowClass, "d-flex media-object position-relative"])
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          src: _unref(messageAvatar)(message),
          "class": "avatar rounded-circle mt-n2",
          width: "75",
          height: "75"
        }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(messageSender)(message)), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(useDateFormat)(_unref(unixTimestampToDate)(message.date), 'h:mm a').value), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          innerHTML: message.content
        }, null, 8, _hoisted_10), Object.keys(message.products || {}).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          "class": "bg-medium-blue font-size-11 p-2"
        }, "Inquiring about...", -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.products, function (product) {
          return _openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(LazyImage, {
            "data-src": product.img || '/img/v5/db-img-search-default.svg',
            "class": "img-fluid image rounded-3",
            width: "75",
            height: "75"
          }, null, 8, ["data-src"])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(product.name), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(product.currency.currency) + " " + _toDisplayString(product.currency.price), 1)])])]), _createElementVNode("div", _hoisted_20, [_cache[1] || (_cache[1] = _createElementVNode("span", {
            "class": "opacity-75 font-size-11"
          }, "Quantity", -1)), _createElementVNode("input", {
            value: product.quantity,
            "class": "form-control d-inline-block w-auto form-control-sm font-size-12 quantity rounded-3",
            type: "text",
            readonly: ""
          }, null, 8, _hoisted_21)])]);
        }), 256))])])) : _createCommentVNode("", true), (message === null || message === void 0 ? void 0 : message.attachments.length) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.attachments, function (attachment) {
          return _openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
            src: '/img/v5/' + attachment.icon
          }, null, 8, _hoisted_24), _createElementVNode("a", {
            "class": "truncate ms-2 text-decoration-none",
            href: attachment.link
          }, _toDisplayString(attachment.name) + "." + _toDisplayString(attachment.extension), 9, _hoisted_25), _createElementVNode("span", _hoisted_26, _toDisplayString(attachment.size), 1)]);
        }), 256))])) : _createCommentVNode("", true)])])], 2);
      }), 256))], 64);
    };
  }
};